export default __webpack_public_path__ + "static/assets/719a1786a555df58b3e000366b751a70.png";